// =============================================
// Limbiq Scents — Wishlist (localStorage)
// =============================================

const Wishlist = (() => {
  const STORAGE_KEY = 'limbiq_wishlist';

  function getAll() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  }

  function save(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
   document.dispatchEvent(new CustomEvent('wishlist:updated')); 
 }

  function add(productId, productHandle) {
    const list = getAll();
    if (!list.find(p => p.id === productId)) {
      list.push({ id: productId, handle: productHandle });
      save(list);
    }
  }

  function remove(productId) {
    save(getAll().filter(p => p.id !== productId));
  }

  function toggle(productId, productHandle) {
    isInWishlist(productId) ? remove(productId) : add(productId, productHandle);
  }

  function isInWishlist(productId) {
    return getAll().some(p => p.id === productId);
  }

  function count() {
    return getAll().length;
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY);
  }

  return { getAll, add, remove, toggle, isInWishlist, count, clear };
})();

// =============================================
// Inicializar botones en product cards
// =============================================
window.addEventListener('load', () => {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const id = Number(btn.dataset.productId);
    const handle = btn.dataset.productHandle;

    if (Wishlist.isInWishlist(id)) btn.classList.add('is-active');

    btn.addEventListener('click', () => {
      Wishlist.toggle(id, handle);
      btn.classList.toggle('is-active');
    });
  });
});
